import { z } from 'zod';
import { UuidSchema } from '../_shared/ids.js';
/**
 * Archivo subido por la redacción (hoy, imágenes de notas y avisos).
 *
 * `url` es la dirección pública directa cuando el bucket la tiene (MinIO en desarrollo, S3 o
 * CDN en producción). Cuando no hay base pública configurada queda en `null` y el panel usa
 * `GET /media/:id/contenido`, que sirve el archivo por la API.
 *
 * `alt` nace vacío y **es requisito para publicar**: la validación está en el servicio de
 * notas, no acá, porque una imagen puede existir un rato sin descripción mientras se escribe.
 */
export const MediaDTO = z
    .object({
    id: UuidSchema,
    /** Nombre original del archivo, solo para mostrar. */
    fileName: z.string().nullable(),
    url: z.string().nullable(),
    alt: z.string().nullable(),
    mimeType: z.string().nullable(),
    sizeBytes: z.number().int().nullable(),
    width: z.number().int().nullable(),
    height: z.number().int().nullable(),
    createdAt: z.string().datetime(),
})
    .strict();
export const MEDIA_ALT_MAX = 300;
export const UpdateMediaRequest = z
    .object({
    alt: z.string().trim().max(MEDIA_ALT_MAX).nullable(),
})
    .strict();
/** Límites de la subida. El servidor los aplica; el panel los usa para avisar antes. */
export const MEDIA_MAX_BYTES = 8 * 1024 * 1024;
export const MEDIA_ALLOWED_MIMES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
export const MEDIA_ERROR_CODES = {
    notFound: 'MEDIA_NO_ENCONTRADA',
    tipoNoPermitido: 'MEDIA_TIPO_NO_PERMITIDO',
    demasiadoGrande: 'MEDIA_DEMASIADO_GRANDE',
    sinArchivo: 'MEDIA_SIN_ARCHIVO',
    sinContenido: 'MEDIA_SIN_CONTENIDO',
};
